// src/components/Contact.jsx
import React, { useState } from "react";
import {
  FiClock,
  FiMapPin,
  FiPhone,
  FiMail
} from "react-icons/fi";
import { useForm, ValidationError } from "@formspree/react";
import ReCAPTCHA from "react-google-recaptcha";
import "./Contact.css";

const FORM_ID = "mqadojda";

export default function Contact() {
  const [state, handleSubmit] = useForm(FORM_ID);
  const [captchaToken, setCaptchaToken] = useState(null);

  const onReCAPTCHAChange = (token) => {
    setCaptchaToken(token);
  };

  return (
    <section className="contact">
      <div className="contact__inner">
        {/* LEFT INTRO */}
        <div className="contact__intro">
          <span className="contact__label">Get In Touch</span>
          <h2 className="contact__heading">
            Always ready to assist with your Tacoma junk removal inquiries.
          </h2>
          <p className="contact__text">
            Have a question, a referral, or need to get in touch for services?
          </p>

          <div className="contact__info-grid">
            <div className="contact__info">
              <div className="contact__info-icon-container">
                <FiClock className="contact__info-icon" />
              </div>
              <div className="contact__info-content">
                <strong>We're Open</strong>
                <div>Monday – Saturday <br/> 08.00 am – 6:00 pm</div>
              </div>
            </div>
            <div className="contact__info">
              <div className="contact__info-icon-container">
                <FiMapPin className="contact__info-icon" />
              </div>
              <div className="contact__info-content">
                <strong>Office Location</strong>
                <div>Tacoma, WA</div>
              </div>
            </div>
            <div className="contact__info">
              <div className="contact__info-icon-container">
                <FiPhone className="contact__info-icon" />
              </div>
              <div className="contact__info-content">
                <strong>Call Us Directly</strong>
                <div>253-220-5010</div>
              </div>
            </div>
            <div className="contact__info">
              <div className="contact__info-icon-container">
                <FiMail className="contact__info-icon" />
              </div>
              <div className="contact__info-content">
                <strong>Send a Message</strong>
                <div>info@tacomasjunkremoval.com</div>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT FORM */}
        <form
          className="contact__form"
          onSubmit={handleSubmit}
        >
          <h3 className="contact__form-heading">Get In Touch</h3>

          <div className="contact__form-grid">
            <label className="contact__field">
              <span className="sr-only">Your Name</span>
              <input id="name" type="text" name="name" placeholder="Your Name" required />
              <span className="contact__field-focus" />
              <ValidationError prefix="Name" field="name" errors={state.errors} />
            </label>
            <label className="contact__field">
              <span className="sr-only">Your Email</span>
              <input id="email" type="email" name="email" placeholder="Your Email" required />
              <span className="contact__field-focus" />
              <ValidationError prefix="Email" field="email" errors={state.errors} />
            </label>
            <label className="contact__field">
              <span className="sr-only">Your Phone</span>
              <input id="phone" type="tel" name="phone" placeholder="Your Phone" />
              <span className="contact__field-focus" />
            </label>
          </div>

          <label className="contact__field">
            <span className="sr-only">Your Message</span>
            <textarea id="message" name="message" placeholder="Your Message" rows="4" required />
            <span className="contact__field-focus" />
            <ValidationError prefix="Message" field="message" errors={state.errors} />
          </label>

          {/* reCAPTCHA */}
          <div style={{ marginBottom: "1rem" }}>
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
              onChange={onReCAPTCHAChange}
            />
          </div>

          <button
            type="submit"
            className="contact__btn"
            disabled={state.submitting || !captchaToken}
          >
            <span>{state.submitting ? "Sending..." : "Send Message"}</span>
            <svg className="contact__btn-arrow" viewBox="0 0 24 24" fill="none">
              <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>

          {state.succeeded && (
            <p className="form-success">✅ Your message has been sent successfully!</p>
          )}
        </form>
      </div>
    </section>
  );
}
